import { render, staticRenderFns } from "./featuredParent.vue?vue&type=template&id=e3186694&scoped=true"
import script from "./featuredParent.vue?vue&type=script&lang=js"
export * from "./featuredParent.vue?vue&type=script&lang=js"
import style0 from "./featuredParent.vue?vue&type=style&index=0&id=e3186694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3186694",
  null
  
)

export default component.exports